import _ from "lodash";
import React from "react";
import Button from "react-bootstrap-button-loader";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import { showError, showSuccess } from "ReduxErrorBar";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { COMMON_FAIL_MESSAGE, maxLengthObjectFc } from "Constants";
import {
  rewardSettingData,
  updateRewardSettings,
} from "RewardssettingsActions";
import LocaleStrings from "Languages";

var MAXLENOBJ = {};
class EditRewards extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      desc: LocaleStrings.gamification_text_preparing_analytics,
      loader: false,
    };
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history);
    this.props.rewardSettingData(this.props.session, (response) => {});
  }

  // On Form Submit Challenges
  onFormSubmit(values) {
    var data = {
      gamification_title: values.gamification_title,
      gamification_desc: values.gamification_desc,
      id: values.id,
    };

    this.setState({ loading: true });

    this.props.updateRewardSettings(this.props.session, data, (result) => {
      if (result.error) {
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        // this.props.reset();
        this.props.showSuccess("Rewards Settings updated successfully!");
        this.props.rewardSettingData(this.props.session, (response) => {});
      }
      this.setState({ loading: false });
    });
  }

  render() {
    var { handleSubmit, pristine, reset, submitting, invalid } = this.props;

    return (
      <form
        onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
        encType="multipart/form-data"
      >
        <div className="form-group">
          <Field
            name="gamification_title"
            label={LocaleStrings.gamification_rewardsettings_title}
            placeholder={LocaleStrings.gamification_rewardsettings_title}
            type="text"
            component={this.renderFieldText}
            mandatory="true"
            labelposition={LABEL_POSITION_TOP}
            value={
              this.props.initialValues
                ? this.props.initialValues.gamification_title
                : ""
            }
            maxlength={
              MAXLENOBJ.gamification_title ? MAXLENOBJ.gamification_title : ""
            }
          />
        </div>
        <div className="form-group">
          <Field
            name="gamification_desc"
            label={LocaleStrings.gamification_rewardsettings_desc}
            placeholder={LocaleStrings.gamification_rewardsettings_desc}
            type="text"
            component={this.renderFieldTextarea}
            mandatory="true"
            labelposition={LABEL_POSITION_TOP}
            value={
              this.props.initialValues
                ? this.props.initialValues.gamification_desc
                : ""
            }
            maxlength={
              MAXLENOBJ.gamification_desc ? MAXLENOBJ.gamification_desc : ""
            }
          />
        </div>

        <div>
          <Button
            className="btn btn-custom-blue"
            loading={this.state.loading}
            type="submit"
            disabled={pristine || invalid || submitting}
          >
            {LocaleStrings.button_save_changes}
          </Button>
        </div>
      </form>
    );
  }
}

function validate(values, props) {
  var errors = {};
  var requiredFields = ["gamification_title", "gamification_desc"];

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });

  if (values["gamification_title"] && MAXLENOBJ) {
    if (values["gamification_title"].length > MAXLENOBJ.gamification_title) {
      errors["gamification_title"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.gamification_title;
    }
  }

  if (values["gamification_desc"] && MAXLENOBJ) {
    if (values["gamification_desc"].length > MAXLENOBJ.gamification_desc) {
      errors["gamification_desc"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.gamification_desc;
    }
  }

  return errors;
}

function mapStateToProps(state) {
  var { session, user } = state;

  //
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    initialValues: state.rewardData ? state.rewardData.response : [],
  };
}

// Export with connect
export default connect(mapStateToProps, {
  showError,
  showSuccess,
  rewardSettingData,
  updateRewardSettings,
})(
  reduxForm({
    validate,
    form: "EditRewardForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(EditRewards)
);
